import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../field.interface';
@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styles: [],
    standalone: false
})
export class CheckboxComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() { }
  ngOnInit() { }
}
